import * as React from 'react';
import { useState } from 'react';
import AdditionalCoverage from '../AdditionalCoverages/AdditionalCoverage/AdditionalCoverage';
import { Coverage } from '../../../types/Coverage';
import MobileAdditionalCoverages from '../AdditionalCoverages/MobileAdditionalCoverages/MobileAdditionalCoverages';
import AdditionalCoverages from '../AdditionalCoverages/AdditionalCoverages';
import { isIPad13, isMobile, isTablet } from 'react-device-detect';

interface TillagsProps {
    handleTillagsBuy: Function;
    price: number;
    paymentTerm: number;
    coverages: Coverage[];
    tillagsBought: boolean;
    disableButton?: boolean;
    showPrice?: boolean;
}

const AdditionalCoveragesPanel: React.FC<TillagsProps> = ({
    handleTillagsBuy,
    price,
    paymentTerm,
    tillagsBought,
    coverages,
    disableButton,
    showPrice
}) => {
    const [openCoverageIndex, setOpenCoverageIndex] = useState(-1);
    const renderTillagsInfo = (coverages: Coverage[]) => {
        return coverages.map((coverage, index) => {
            return (
                <AdditionalCoverage
                    key={index}
                    tillagsCoverageData={coverage}
                    isOpen={openCoverageIndex === index}
                    handleTillagsBuy={handleTillagsBuy}
                    paymentTerm={paymentTerm}
                    price={coverage.price}
                    onClick={() =>
                        setOpenCoverageIndex(
                            index === openCoverageIndex ? -1 : index
                        )
                    }
                />
            );
        });
    };

    const handleClickAnywhere = e => {
        if (
            !e.target.classList.contains('dont-hide-card-click') &&
            e.target.tagName != 'H6'
        ) {
            setOpenCoverageIndex(-1);
        }
    };

    return (
        <>
            {isMobile && !(isTablet || isIPad13) ? (
                <MobileAdditionalCoverages
                    handleTillagsBuy={handleTillagsBuy}
                    price={price}
                    paymentTerm={paymentTerm}
                    coverages={coverages}
                    tillagsBought={tillagsBought}
                    handleClickAnywhere={handleClickAnywhere}
                    renderTillagsInfo={renderTillagsInfo}
                    disableButton={disableButton}
                    showPrice={showPrice}
                />
            ) : (
                <AdditionalCoverages
                    handleTillagsBuy={handleTillagsBuy}
                    price={price}
                    paymentTerm={paymentTerm}
                    coverages={coverages}
                    tillagsBought={tillagsBought}
                    handleClickAnywhere={handleClickAnywhere}
                    renderTillagsInfo={renderTillagsInfo}
                    disableButton={disableButton}
                    showPrice={showPrice}
                />
            )}
        </>
    );
};

export default AdditionalCoveragesPanel;
